export const selectCallInfo = (state) => state.callInfo;
export const selectIsInCall = (state) => selectCallInfo(state).callSession?.isInCall ?? false;
export const selectIsInGroupCall = (state) => selectCallInfo(state).isInGroupCall;
export const selectSessionId = (state) => selectCallInfo(state).callSession?.id ?? null;
